import React from 'react'

const Xls = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/xls',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g transform='translate(1 1)' fill='none' fillRule='evenodd'>
      <rect fill={primaryColor} width='90%' height='90%' rx={2} />
      <path
        d='M10.729 14l-1.624-3.26c-.061-.115-.134-.346-.194-.668h-.024a7.21 7.21 0 0 1-.218.694L7.032 14H4.5l3.005-5.006L4.755 4h2.594l1.345 2.991c.108.244.193.527.278.848h.037a8.68 8.68 0 0 1 .291-.873L10.802 4h2.364l-2.824 4.955L13.25 14h-2.521z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Xls
